import React from 'react'
import { compose } from 'recompose'
import classnames from 'classnames'
import { Button } from 'semantic-ui-react'

const TextInput = (props) => {
  const { label, options, input, style, editable=true, meta: { touched, error } } = props
  const activeClass = classnames({error: (touched && error)})

  return (
    <div className='fieldRow' style={{...style}}>
      <span className='fieldLabel'>
        {label}
        {require ? <span className='require'>*</span> : null}
        {touched && error ? <span className='error'>{error}</span> : null}
      </span>
      <div className={`fieldInput ${editable!==false?'editableTabSelectionInput':''}`} name={input.name}>
        <Button.Group basic>
          {
            options ? options.map(opt => 
              <Button
                key={`opt_${opt.value}`}
                type='button'
                color={opt.color ? opt.color : 'grey'}
                onClick={() => input.onChange(opt.value)}
                active= {input.value === opt.value} 
                disabled={editable===false}
              >
                {opt.title}
              </Button>
              ) : null
          }
        </Button.Group>
      </div>
    </div>
  )
}

export default compose()(TextInput)